import React, { useState } from "react";
import { motion, useScroll, useTransform } from "framer-motion";
import awordbanner from "../image/Awardbanner.webp";
import { AwardData } from "./AwardObj";
import Timeline from "./TimeLine";

const groupByYear = (data) => {
  return data.reduce((acc, item) => {
    const year = item.date?.split(" ")?.[1] || "A JOURNEY OF INNOVATION & RECONGNITION";
    if (!acc[year]) acc[year] = [];
    acc[year].push(item);
    return acc;
  }, {});
};

const Award = () => {
  const [selectedItem, setSelectedItem] = useState(null);
  const { scrollY } = useScroll();

  // Parallax effect
  const y = useTransform(scrollY, [0, 300], [0, 100]);

  const grouped = groupByYear(AwardData);

  return (
    <div className="bg-white text-black min-h-screen overflow-x-hidden">

      {/* ================= HERO ================= */}
      <div className="relative w-full mt-[70px] md:mt-[80px] overflow-hidden">
  
  <motion.img
    src={awordbanner}
    alt="Awards Banner"
    style={{ y }}
    className="w-full h-[110px] sm:h-[200px] md:h-[350px] object-cover object-center"
  />

  {/* Gradient Overlay */}
  <div className="absolute inset-0 bg-gradient-to-t from-black/40 to-transparent"></div>

</div>

      {/* ================= TIMELINE ================= */}
      <div className="max-w-7xl mx-auto px-4 py-6 relative">

        {/* Vertical Line */}
        <div className="absolute left-1/2 w-[3px] bg-gradient-to-b from-yellow-400 via-yellow-600 to-transparent h-[90%] mt-10 hidden md:block blur-[1px]"></div>

        {Object.keys(grouped)
          .sort((a, b) => b - a)
          .map((year) => (
            <div key={year} className="mb-20">

              {/* YEAR */}
              <h2 className="text-l sm:text-xl md:text-4xl underline text-center font-bold text-[#800000] mb-6 md:mb-12">
                {year}
              </h2>

              {/* ITEMS */}
              <div className="grid grid-cols-1 md:grid-cols-2 sm:gap-6 md:gap-8">
  {grouped[year].map((item, index) => (
    <Timeline
      key={item.id}
      item={item}
      isLeft={index % 2 === 0}
      setSelectedItem={setSelectedItem}
    />
  ))}
</div>
            </div>
          ))}
      </div>

      {/* ================= MODAL ================= */}
      {selectedItem && (
        <motion.div
          initial={{ opacity: 0 }}
          animate={{ opacity: 1 }}
          className="fixed inset-0 bg-black/80 backdrop-blur-lg flex items-center justify-center z-50 p-4"
          onClick={() => setSelectedItem(null)}
        >
          <motion.div
            initial={{ scale: 0.6 }}
            animate={{ scale: 1 }}
            className="bg-white text-black max-w-lg md:max-w-3xl w-full rounded-xl overflow-hidden shadow-2xl relative"
            onClick={(e) => e.stopPropagation()}
          >
            <img
              src={
                Array.isArray(selectedItem.url)
                  ? selectedItem.url[0]
                  : selectedItem.url
              }
              alt={selectedItem.title}
              className="w-full max-h-[60vh] object-contain"
            />

            <div className="p-6">
              <h2 className="text-xl text-blue underline text-center font-bold">
                {selectedItem.title}
              </h2>

              <p className="mt-3 text-black ">{selectedItem.description}</p>

              
            </div>

            <button
              className="absolute top-4 right-6 text-black font-bold  text-2xl"
              onClick={() => setSelectedItem(null)}
            >
              ✕
            </button>
          </motion.div>
        </motion.div>
      )}
    </div>
  );
};

export default Award;